import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCustomizeTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.8842 5.37827L12 4.37142C11.7987 3.88477 11.5968 3.39813 11.3943 2.91148L9.8943 2.98867L9.01342 2.10768L9.0906 0.607467C8.60403 0.406097 8.11745 0.204167 7.63087 0.00167809L6.62416 1.11761H5.3792L4.37081 0C3.88423 0.20137 3.39765 0.4033 2.91107 0.605789L2.98826 2.106C2.63591 2.4584 2.45973 2.6346 2.10738 2.98699L0.607383 2.9098C0.40604 3.39645 0.204139 3.88309 0.00167785 4.36974L1.11745 5.37659V6.62173L0 7.63026C0.201342 8.11691 0.403244 8.60355 0.605705 9.0902L2.1057 9.013L2.98658 9.894L2.9094 11.3942C3.39597 11.5956 3.88255 11.7975 4.36913 12L5.37584 10.8841H6.62081L7.62752 12C8.11409 11.7986 8.60067 11.5967 9.08725 11.3942L9.01007 9.894C9.36242 9.5416 9.53859 9.3654 9.89094 9.013L11.3909 9.0902C11.5923 8.60355 11.7942 8.11691 11.9966 7.63026L10.8809 6.62341V5.37827H10.8842ZM6 9.02139C4.33221 9.02139 2.97987 7.66886 2.97987 6.00084C2.97987 4.33282 4.33221 2.98028 6 2.98028C7.66779 2.98028 9.02013 4.33282 9.02013 6.00084C9.02013 7.66886 7.66779 9.02139 6 9.02139Z",
		fill: "white"
	})
});
export default SvgCustomizeTable;
